import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractTimeInput} from "../abstract-time-input";
import {FUIEventsService} from "../../../../events/events.service";
@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineTimeInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-time-input",
    styleUrls: ["./inline-time-input.component.scss"],
    templateUrl: "./inline-time-input.component.html",
    standalone: false
})
export class FUIInlineTimeInputComponent extends FUIAbstractTimeInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService) {
        super(elementRef, changeDetectorRef, eventsService);
    }
}
